import {SET_ACTIVE_APP_INTEGRATIONS} from "../actions/types";

export default (state = {}, action) => {
	switch(action.type) {
        case SET_ACTIVE_APP_INTEGRATIONS:
			return {...state, activeAppIntegrations: action.payload  != undefined  ? action.payload : {}}
		default:
            return state;
	}
}